"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ToggleButtonIcon = void 0;
var _styled = _interopRequireDefault(require("@emotion/styled"));
var _lodestarIcons = require("@smartsheet/lodestar-icons");
var _ursaIcons = require("@smartsheet/ursa-icons");
var _react = _interopRequireDefault(require("react"));
var _useTheme = require("../../../../theme/utils/useTheme");
var _selectV2Theme = require("../selectV2Theme");
const ToggleButtonLodestar = (0, _styled.default)(_lodestarIcons.ArrowDownIcon)`
    // Make this a bit smaller to account for the shared styles from ActionButton.
    position: relative;
    top: -2px;
    left: -2px;
`;
const ToggleButtonWrapper = (0, _styled.default)("span")`
    // Make this a bit smaller to account for the shared styles from ActionButton.
    // margin: -4px;
    height: ${_ref => {
  let {
    themeMode
  } = _ref;
  return _selectV2Theme.selectV2Theme.actionButtons.buttonWrapperSize(themeMode);
}};
    width: ${_ref2 => {
  let {
    themeMode
  } = _ref2;
  return _selectV2Theme.selectV2Theme.actionButtons.buttonWrapperSize(themeMode);
}};
`;
const ToggleButtonIcon = () => {
  const {
    key
  } = (0, _useTheme.useTheme)();
  const themeMode = key;
  return /*#__PURE__*/_react.default.createElement(ToggleButtonWrapper, {
    themeMode: themeMode
  }, (() => {
    if (themeMode === "ursa-light") {
      return /*#__PURE__*/_react.default.createElement(_ursaIcons.ChevronDownIcon, {
        size: 16
      });
    } else {
      return /*#__PURE__*/_react.default.createElement(ToggleButtonLodestar, null);
    }
  })());
};
exports.ToggleButtonIcon = ToggleButtonIcon;
//# sourceMappingURL=ToggleButtonIcon.js.map